import { useState } from "react"

import useIsDesktop from "@hooks/useIsDesktop"

import { faIcon } from "@utils/faIcon"

import { IconButton } from "@atoms"

import SearchInput from "@molecules/SearchInput/SearchInput"

import useViewBar from "@organisms/ViewBar/ViewBar.context"
import ViewBarPortal from "@organisms/ViewBar/ViewBarPortal/ViewBarPortal"

import { ViewBarSearchButtonProps } from "./ViewBarSearchButton.types"

export default function ViewBarSearchButton(props: ViewBarSearchButtonProps) {
    const { defaultValue, onValueChange } = props

    const isDesktop = useIsDesktop()
    // A restored term opens the bar without focus, so returning to the list doesn't raise the keyboard.
    const [isSearchActive, setIsSearchActive] = useState(!!defaultValue)
    const [shouldAutoFocus, setShouldAutoFocus] = useState(false)

    // The mobile search row portals into ViewBar.Root; assert that ancestor at mount rather than on the first tap.
    useViewBar()

    const toggleSearch = () => {
        // Closing clears the term, so a collapsed bar never hides an active search.
        if (isSearchActive) {
            onValueChange("")
        } else {
            setShouldAutoFocus(true)
        }
        setIsSearchActive(!isSearchActive)
    }

    if (isDesktop) {
        return <SearchInput type="field" defaultValue={defaultValue} onValueChange={onValueChange} />
    } else {
        return (
            <>
                <IconButton
                    size="md"
                    variant="ghost"
                    icon={faIcon({ name: "magnifying-glass", style: "regular" })}
                    onClick={toggleSearch}
                    noDebounce={true}
                    aria-label={isSearchActive ? "Close search" : "Open search"}
                    isPressed={isSearchActive}
                />
                {isSearchActive && (
                    <ViewBarPortal>
                        <SearchInput
                            type="bar"
                            defaultValue={defaultValue}
                            onValueChange={onValueChange}
                            autoFocus={shouldAutoFocus}
                        />
                    </ViewBarPortal>
                )}
            </>
        )
    }
}
